import React from "react";
import square from "../../../assets/images/icons/square.svg";
import { convert, UNIT_CONVERSION } from "_common/_utils/unityUtils";
import { useTranslation } from "react-i18next";

type Props = {
    surfaceMin: number;
};

export function PropertyCardSurfaces({ surfaceMin }: Props) {
    const { t } = useTranslation();

    return (
        <div className="flex gap-1 items-center">
            <img src={square} alt={"square icon"} />
            <div className={"whitespace-nowrap"}>
                {t("propertiesPage.card.surfaces", {
                    ft2: convert(surfaceMin, UNIT_CONVERSION.M2_TO_FT2_BACK),
                    m2: Math.round(surfaceMin * 100) / 100,
                })}
            </div>
        </div>
    );
}
